import { IPaths } from 'Shared/Core/ApiPath/IPaths';

export const BasicInfoPaths: IPaths = {
  Reminder: {
    List: '/BasicInfo/Reminder/List',
    Create: '/BasicInfo/Reminder/Create',
    Update: '/BasicInfo/Reminder/Update',
  },
  VahedBimeh: {
    List: '/BasicInfo/VahedBimeh/List',
  },
};
